export default class EstatedMarketAssessment {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.year = obj.year;
    this.land_value = obj.land_value;
    this.improvement_value = obj.improvement_value;
    this.total_value = obj.total_value;
  }
}
